import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal as SemanticModal } from "semantic-ui-react";
import "./modal-content.scss";

export const ModalContent = ({ className = "", ...props }) => (
  <SemanticModal.Content
    {...props}
    className={clsx("ha-modal-content", className)}
  />
);

ModalContent.propTypes = {
  className: PropTypes.string,
};
